import { createAsyncThunk, isRejected } from '@reduxjs/toolkit';
import {
  actions as appStorageActions,
  constants as appStorageConstants,
  utils as appStorageUtils,
} from '@saucelabs/sl-module-app-storage';

import types from './types';
import selectors from './selectors';
import { GlobalState } from '../../reducers';

export type FetchFilesArguments = {
  paginationPage?: number;
  entriesPerPage?: number;
  groupId?: string;
}

const fetchFiles = createAsyncThunk(
  types.FETCH_FILES,
  async (payload: FetchFilesArguments, { dispatch, getState, rejectWithValue }) => {
    const state = getState() as GlobalState;
    const previousFetchFilesArguments = selectors.fetchFilesArgumentsSelector(state);

    const nextFetchFilesArguments = {
      iconRepresentation: appStorageConstants.APP_STORAGE_ICON_REPRESENTATION.hash,
      ...previousFetchFilesArguments,
      ...payload,
      shouldCancelPreviousRequest: true,
    };

    if (payload.groupId && payload.groupId !== previousFetchFilesArguments.groupId) {
      nextFetchFilesArguments.paginationPage = 1;
    }

    try {
      const globalFetchFilesResult = await dispatch(
        appStorageActions.fetchFiles(nextFetchFilesArguments),
      );

      if (isRejected(globalFetchFilesResult)) {
        const serverError = globalFetchFilesResult.payload as appStorageUtils.SerializedApiError;
        throw serverError;
      }

      return globalFetchFilesResult.payload;
    } catch (error) {
      if (error instanceof Error) {
        return rejectWithValue(appStorageUtils.handleApiError(error));
      }

      return rejectWithValue(error);
    }
  },
);

export default {
  fetchFiles,
};
